import React from 'react';
import { Link } from "react-router-dom";
import {createExperiment} from '../services/ExperimentService';
import {uploadExperimentImport} from '../services/ExperimentService';
import PartForm from './components/PartForm';

class CreateExperiment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           jwtToken: props.jwtToken,
           name:  "",
           description: "",
           timeoutPeriod: 15,
           parts: [],
           partKeyCount: 0,
           importFile: null
        };

        this.handleAddPart = this.handleAddPart.bind(this);
        this.handleExperimentInputChange = this.handleExperimentInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.updatePartValues = this.updatePartValues.bind(this);
        this.removePart = this.removePart.bind(this);
        this.handleImportFileChange = this.handleImportFileChange.bind(this);
        this.handleImport = this.handleImport.bind(this);
    }

    handleImport = (e) => {
        e.preventDefault();
        if (this.state.importFile == null) {
            window.alert("Please select an import file to upload.");
        } else {
            uploadExperimentImport(this.state.jwtToken, this.state.importFile)
            .then(response =>
                {
                    if (response.ok) {
                        window.alert("Experiment imported successfully.");
                        window.location.pathname = "/";
                    } else {
                        window.alert("Experiment could not be imported.");
                    }
                }
            );
        }
    }

    handleImportFileChange = (e) => {
        this.setState({ importFile: e.target.files[0]});
    }

    removePart = (id) => {
        this.setState({parts: this.state.parts.filter(function(part) {
            return part.partNum !== id
        })});
    }

    updatePartValues = (partData) => {
        var existingParts = this.state.parts;
        var index = existingParts.findIndex( (part) => part.partNum === partData.partNum);
        existingParts[index] = partData;
        this.setState({ parts: existingParts});
    }

    handleAddPart() {
        var existingParts = this.state.parts;
        existingParts.push({   partNum: this.state.partKeyCount,
                               name: "",
                               description: "",
                               designType: "BETWEEN_SUBJECT",
                               repetitionCount: 1,
                               variables: []});
        this.setState({ parts: existingParts, partKeyCount: (this.state.partKeyCount +1)});
    };

    handleExperimentInputChange = (e) => {
        if (e.target.name === "name") {
            this.setState({ name: e.target.value});
        }
        else if (e.target.name === "description") {
            this.setState({ description: e.target.value});
        }
        else if (e.target.name === "timeoutPeriod") {
            this.setState({ timeoutPeriod: e.target.value});
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.state.name === "") {
            this.setState({errorMessage: "Name field must not be empty."});
        } else {
            createExperiment(this.state.jwtToken, this.state.name, this.state.description, this.state.timeoutPeriod, this.state.parts)
            .then(response =>
                {
                    if (response.ok) {
                        window.alert("Experiment saved successfully.");
                        window.location.pathname = "/";
                    } else {
                        response.json().then(body => {
                            const msg = body?.message || "";
                            if (msg.toLowerCase().includes("duplicate part") || msg.toLowerCase().includes("duplicate names")) {
                                alert("A part with this name already exists in this experiment. Please use a unique name for each part.");
                            } else if (msg.toLowerCase().includes("access token") || msg.toLowerCase().includes("experiment name")) {
                                alert("An experiment with this name already exists. Please choose a different name.");
                            } else {
                                alert("Experiment could not be saved.");
                            }
                        }).catch(() => alert("Experiment could not be saved."));
                    }
                }
            );
        }
    };

    render() {
    var renderedParts = [];
    if (typeof this.state.parts !==  "undefined"){
        for (var i = 0; i < this.state.parts.length; i++) {
            renderedParts.push( <PartForm key={this.state.parts[i].partNum} handleRemove={this.removePart}
                                    handleUpdate={this.updatePartValues} data={this.state.parts[i]}/> );
        }
    }
    return (
    <>
        <div className="row" style={{marginLeft: "4%", marginRight: "4%"}}>
            <h1>
                <Link to="/">
                    <span title="Return to experiment listing">All experiments/</span>
                </Link>
                Create new experiment
            </h1>
            <h3 style={{marginTop: "20px"}}>Import</h3>
            <hr style={{marginTop:"0px"}}/>
            <div style={{display: "flex", flexWrap: "wrap"}}>
                <input style={{width: "40%"}} className="form-control" type="file" name="import"
                       onChange={(e) => this.handleImportFileChange(e)} />
                <button style={{marginLeft: "10px"}} type="button" className="btn btn-primary"
                        onClick={this.handleImport}>Upload</button>
            </div>
            <h3 style={{marginTop: "40px"}}>Manual</h3>
            <hr style={{marginTop:"0px"}}/>
            <form style={{paddingTop:"5px", marginBottom: "20px"}}>
                <div style={{display: "flex", flexWrap: "wrap"}}>
                    <div style={{width: "25%", marginRight: "50px"}}>
                        <div className="form-group">
                            <label>Name</label>
                            <input className="form-control" type="text" name="name" placeholder="New experiment name"
                            onChange={(e) => this.handleExperimentInputChange(e)} />
                        </div>
                        <div style={{marginTop: "20px"}} className="form-group">
                            <label>Timeout [minutes]</label>
                            <input className="form-control" type="text" name="timeoutPeriod" placeholder="15"
                            onChange={(e) => this.handleExperimentInputChange(e)} />
                        </div>
                    </div>
                    <div style={{width: "30%"}} className="form-group">
                        <label>Description</label>
                        <textarea className="form-control" name="description" placeholder="Description"
                        onChange={(e) => this.handleExperimentInputChange(e)} />
                    </div>
                </div>

                <h2>Parts</h2>
                <div id="partsArea">
                    <div className="alert alert-warning" style={{textAlign: "center" }} hidden={this.state.parts.length > 0}>
                      <strong>No part data</strong>
                    </div>
                </div>
                {renderedParts}



                <button style={{marginRight: "20px"}} type="button"
                    id="newPartButton" className="btn btn-default" onClick={this.handleAddPart} >
                    New part
                </button>

                <button type="submit" id="submitButton" className="btn btn-primary" onClick={this.handleSubmit} >
                    Submit
                </button>
            </form>
        </div>
    </>
    );
    }
}

export default CreateExperiment;
